import ErrorComponent from "@/components/atoms/ErrorComponent";
import CourseHeader from "@/components/molecules/card-headers/courses/CourseHeader";
import CourseDetailsCard from "@/components/molecules/cards/courses/CourseDetailsCard";
import { UUID_REGEX } from "@/constants/regexs";
import { pluralize } from "@/helpers/utils";
import ICourse from "@/interfaces/Course";
import { faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FC, useState } from "react";
import { Card, Col, Nav, Row, Tab } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SimpleBar from "simplebar-react";

const CourseView: FC = () => {
  const { id } = useParams<{ id: string }>();
  const [course, setCourse] = useState<ICourse>();
  const [totals, setTotals] = useState({
    companies: 0,
    people: 0,
  });

  const onGetTotal = (key: string, total: number) => {
    setTotals((prev) => ({ ...prev, [key]: total }));
  };

  if (!id || !UUID_REGEX.test(id)) {
    return (
      <ErrorComponent error={{ status: 404, data: {} }} absolute returnButton />
    );
  }

  return (
    <div className="formalys-page formalys-detail-page">
      {course && <CourseHeader id={id} />}
      <Row className="g-3">
        <Col xxl={4} xl={5}>
          <CourseDetailsCard id={id} card callBack={setCourse} />
        </Col>
        {course && (
          <Col xxl={8} xl={7}>
            <Card>
              <Tab.Container defaultActiveKey="companies">
                <SimpleBar>
                  <Card.Header className="p-0 border-bottom">
                    <Nav className="nav-tabs border-0 flex-nowrap tab-contact-details">
                      {/* {(data!.role === "SDR" || data!.role === "AE") && ( */}
                      <Nav.Item>
                        <Nav.Link
                          eventKey="companies"
                          className="d-flex align-items-center py-3 px-x1 mb-0"
                        >
                          <FontAwesomeIcon
                            icon={faUser}
                            className="text-600 tab-icon"
                          />
                          <h6 className="text-600 mb-0 ms-1">
                            {pluralize("Entreprise", totals.companies)}
                            &nbsp;(
                            {totals.companies})
                          </h6>
                        </Nav.Link>
                      </Nav.Item>
                      {/* )} */}

                      <Nav.Item>
                        <Nav.Link
                          eventKey="people"
                          className="d-flex align-items-center py-3 px-x1 mb-0"
                        >
                          <FontAwesomeIcon
                            icon={faUsers}
                            className="text-600 tab-icon"
                          />
                          <h6 className="text-600 mb-0 ms-1">
                            {pluralize("Apprenant", totals.people)}
                            &nbsp;(
                            {totals.people})
                          </h6>
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </Card.Header>
                </SimpleBar>
                <Card.Body className="bg-light">
                  <Tab.Content>
                    {/* <Tab.Pane eventKey="companies">
                      <CompaniesCard
                        courseId={parseInt(id)}
                        onGetTotal={(total) => onGetTotal("companies", total)}
                      />
                    </Tab.Pane>

                    <Tab.Pane eventKey="people">
                      <peopleCard
                        courseId={parseInt(id)}
                        onGetTotal={(total) => onGetTotal("people", total)}
                      />
                    </Tab.Pane> */}
                  </Tab.Content>
                </Card.Body>
              </Tab.Container>
            </Card>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default CourseView;
